var exports = {
  "o": "x24da60e8--465453--block",
};

module.exports = exports;
